import _ from "lodash";
/*
  This is not an ideal way to handle the title formatting since it's not very flexible
  and will require additional work if we need to add more integration or flow types
  that require special handling. It would be better to have a more generic way but
  this is a good start.
*/

const formatTitle = (flowType, prefix, replaceText) => {
  let title = flowType.name.replace(new RegExp(replaceText, "g"), prefix);

  // Remove 'to 3rd Party' and 'from 3rd Party' from the title
  title = title.replace(/ to 3rd Party/g, "");
  title = title.replace(/ from 3rd Party/g, "");

  // If the title isn't plural, add an 's' to the end
  if (title[title.length - 1] !== "s") title += "s";

  // If the title includes 'Organizations', replace it with 'Organization Data'
  // We do this after adding the 's' because we want don't want to the title to be 'Organization Datas'
  if (title.includes("Organizations")) {
    title = title.replace(/Organizations/g, "Organization Data");
  }

  // If the title doesn't include the prefix and doesn't start with 'Register', add the prefix
  // Register is a special case where we don't want to add a Send or Receive prefix because 'Register'
  // is already a verb
  if (!title.includes(prefix) && !_.startsWith(title, "Register")) {
    title = `${prefix} ${title}`;
  }

  return title;
};

const mapSystems = (
  systems // we don't need file types so we can take them out since its a lot of information
) => systems.map(({ fileTypes, ...restSys }) => restSys);

const processFlow = (flowType, name) => {
  if (flowType.id.includes("passthrough")) return null;

  const to = {};
  const from = {};

  const isInSource = flowType.sourceSystems.some((sys) => sys.name === name);
  const isInDestination = flowType.destinationSystems.some(
    (sys) => sys.name === name
  );

  if (isInSource) {
    to.title = formatTitle(flowType, "Send", "Receive");
    to.systems = mapSystems(flowType.destinationSystems);
  }

  if (isInDestination) {
    from.title = formatTitle(flowType, "Receive", "Send");
    from.systems = mapSystems(flowType.sourceSystems);
  }

  return { name: flowType.name, to, from };
};

export default processFlow;
